export const CAPACITY_SEARCH_SETTINGS = {
	capacitySearchTabsListItems: ['Projects', 'Notes', 'Tasks'],
	pickupDate: 'Tomorrow',
	settingType: {
		accountSetting: 'AccountSetting',
		userSetting: 'UserSetting',
	},
};

export function getCapacitySearchTabs(isProjectsEnabled) {
	return {
		Projects: {
			label: 'Projects',
			value: 0,
		},
		Notes: {
			label: 'Notes',
			value: isProjectsEnabled ? 1 : 0,
		},
		Tasks: {
			label: 'Tasks',
			value: isProjectsEnabled ? 2 : 1,
		},
	};
}
